import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {isUndefined} from 'lodash'
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

function AktivitetsTyp(props) {
    const currencies = [
        {
            value: "",
            disabled:true,
            show:true,
            label: <IntlMessages id="Choose"/>,
        },
        {
            value: 1,
            disabled:false,
            show:true,
            label: 'Företag',
        },
        {
            value: 0,
            disabled:false,
            show:true,
            label: 'Konsument',
        },
        {
            value: 2,
            disabled:false,
            show:true,
            label: 'Filial',
        },
        {
            value: 3,
            disabled:false,
            show:true,
            label: <IntlMessages id="Supplier"/>,
        },
        {
            value: 4,
            disabled:false,
            show:props.Flags.Bransch ===3,
            label: 'Resurs',
        },
    ];
    const [value, setValue]=React.useState(props.Type)
    const classes = useStyles();
    const handleChange=(e)=>{
        console.log(e.target.value)
        setValue(e.target.value)
        props.onChangeKund("Type",e.target.value)
    }
    return (
            <div>
                <TextField
                    label={<IntlMessages id="appKontoModule.Type"/>}
                    select
                    variant="outlined"
                    size="small"
                    value={value}
                    fullWidth
                    onChange={handleChange}
                    SelectProps={{
                        native: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                >
                    {currencies.map((option) => {
                        if(option.show === true){
                            return ( <option key={option.value} disabled={option.disabled} value={option.value}>
                                {option.label}
                            </option>)
                        }
                    })
                    }
                </TextField>
            </div>
    );
}
export default AktivitetsTyp;